<template>
  <section>
    <h2 class="h2Title">게시판 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="게시판 생성일"
                                        :value="searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>


              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="이름 검색"
                                  v-model="searchValue" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: 'board/form'})" color="#666" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="boards"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="boardId"
            class="elevation-1"
            :footer-props="{showFirstLastPage: true}"
            disable-sort
        >

          <template v-slot:item.boardIndex="{item}">
            {{item.idx}}
          </template>
          <template v-slot:item.boardName="{value, item}">
            <a @click.stop="onRowClick(item.boardId)">
            {{value}}
            </a>
          </template>

          <template v-slot:item.boardType="{value}">
            <template v-for="(t, index) in boardTypeItems">
              <span v-if="t.value === value"  :key="index">
                <v-icon>{{t.icon}}</v-icon>
                {{t.text}}
              </span>
            </template>
          </template>

          <template v-slot:item.targetType="{item, value}">

            <span v-if="item.group.groupName"> {{item.group.groupName}} </span>
            <template v-for="(t, index) in targetTypeItems">
              <span v-if="t.value === value"  :key="index"> {{t.text}} </span>
            </template>

          </template>


          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.activated="{ value }">
            {{ value ? '사용' : '사용안함' }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click.stop="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click.stop="deleteBoard(item)"
            >
              mdi-delete
            </v-icon>
          </template>


        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";

import boardApi from '@/api/BoardApi'
import roleApi from '@/api/RoleApi'
import _ from "lodash";

export default {
  name: "Board",
  components: {
    'date-range-component': DateRageComponent
  },
  data: () => ({
    date: new Date(),
    // fromDate: new Date().toISOString().substr(0, 10),
    // toDate: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    boardRoleItems: [],
    boardTypeItems: [
      {
        'value': 'TYPE_GENERAL',
        'text': '일반게시판',
        'icon': 'mdi mdi-clipboard-text-outline'
      },
      {
        'value': 'TYPE_PHOTO',
        'text': '사진게시판',
        'icon': 'mdi mdi-camera'
      },
      {
        'value': 'TYPE_SCHEDULE',
        'text': '일정게시판',
        'icon': 'mdi mdi-calendar'
      }
    ],
    targetTypeItems: [{
      'value': 'TARGET_DEPARTMENT',
      'text': '분과',
      'color': 'primary'
    },
    {
      'value': 'TARGET_CLUB',
      'text': '동호회',
      'color': 'green'
    }, {
      'value': 'TARGET_GENERAL',
      'text': '홈페이지',
      'color': 'gray'
    }],
    keywordType: ['아이디', '이름', '닉네임', '휴대폰'],
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    emailType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    smsType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    selected: [],
    headers: [
      {text: '번호', value: 'boardIndex', align: 'left'},
      {text: '게시판 명', value: 'boardName', align: 'left'},
      {text: '게시판 유형', value: 'boardType'},
      {text: '모임 분류', value: 'targetType'},
      {text: '페이지 사이즈', value: 'pageSize', align: 'center'},
      {text: '생성일', value: 'createdAt'},
      {text: '사용여부', value: 'activated', align: 'left'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchState: null,
      searchRole: null,
      keyType: null,
      searchKeyword: null,
      boardname: null,
      name: null,
      local: null,
      fromJoin: null,
      toJoin: null,
      sms: null,
      page: 1
    },
    boards: [],
    totalItems: 0,
    searchDate: [],
    dialogVisible: false,
    selectedBoard: {},
    waitingSearch: false,
    searchValue: null,
    options:{}
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    searchValue: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    onRowClick(value) {
      this.$router.push({path:`/board/${value}/articles`});
    },
    initSearch() {
      for (const [key] of Object.entries(this.param)) {
        this.param[key] = '';
      }
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      // const {  page, size } = this.options;
      const params = {...this.param, ...this.options};
      if (this.activeItem > 0) {
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      params.size =  params.size ? params.size : params.itemsPerPage??10;
      boardApi.list(params).then(data => {
        this.totalItems = data.totalElements;
        this.boards = data.content.map((b, i) => {
          b.idx = this.totalItems - i - (( (params.page??1) - 1) * params.size);
          return b;
        });
        this.$store.commit('setParams', params);
      });
    },
    createForm(){
      this.selectedBoard = {};
      this.dialogVisible = true;
      // this.$router.push({path: '/board/form'})
    },
    savedBoard() {
      this.dialogVisible = false;
      this.search();
    },
    updateForm(item) {
      this.selectedBoard = _.cloneDeep(item);
      // this.dialogVisible = true;
      this.$router.push({path:`/board/form/${item.boardId}`});
    },
    deleteBoard(item) {
      if(confirm('삭제하시겠습니까?')) {
        boardApi.delete(item.boardId).then(() => {
          this.search();
          // this.datas = this.datas.filter(d => d.menu !== item.menu && d.request_type !== item.request_type);
        });
      }
    }
  },
  created: function () {
    this.param.searchState = this.$route.params.state;

    roleApi.list(true).then(data => {
      this.boardRoleItems = data;
    });
    // this.search();
    // boardApi.list(this.param).then(data => {
    //   this.boards = data.content;
    //   this.totalItems = data.totalElements;
    // });

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
